import { apiFetch } from 'modules/shared/fetch';
import JWTDecode from 'jwt-decode';
import { AuthToken } from 'modules/auth/authToken';

interface DecodedJWT {
  sub: string;
  org: string;
  [key: string]: any;
}

interface EmailSubscription {
  id: string;
  email: string;
  subscriptions: string[];
}

interface GetEmailsParams {
  appEnvironment: string;
}

interface AddEmailParams {
  appEnvironment: string;
  email: string;
  subscriptions: string[];
}

interface UpdateEmailParams {
  appEnvironment: string;
  emailId: string;
  subscriptions: string[];
}

interface DeleteEmailParams {
  appEnvironment: string;
  emailId: string;
}

const getOrganizationId = async (): Promise<string> => {
  const token = await AuthToken.get();
  if (!token) {
    throw new Error('No authentication token found');
  }
  const decoded = JWTDecode<DecodedJWT>(token);
  return decoded.org || decoded.sub;
};

export default class SupportAlertEmailsService {
  static async getEmails({ appEnvironment }: GetEmailsParams) {
    const response = await apiFetch('/notifications/emails', {
      // @ts-ignore
      appEnvironment,
    });

    return response?.data;
  }

  static async addEmail({ appEnvironment, email, subscriptions }: AddEmailParams) {
    const organizationId = await getOrganizationId();

    const response = await apiFetch('/notifications/emails', {
      // @ts-ignore
      appEnvironment,
      method: 'POST',
      body: {
        organization_id: organizationId,
        emails: [
          {
            email,
            subscriptions,
          },
        ],
      },
    });

    return response?.data;
  }

  static async updateEmail({ appEnvironment, emailId, subscriptions }: UpdateEmailParams) {
    const response = await apiFetch(`/notifications/emails/${emailId}`, {
      // @ts-ignore
      appEnvironment,
      method: 'PUT',
      body: {
        subscriptions,
      },
    });

    return response?.data;
  }

  static async deleteEmail({ appEnvironment, emailId }: DeleteEmailParams) {
    const response = await apiFetch(`/notifications/emails/${emailId}`, {
      // @ts-ignore
      appEnvironment,
      method: 'DELETE',
    });

    return response?.data;
  }

  static async getEventTypes({ appEnvironment }: { appEnvironment: string }) {
    const response = await apiFetch('/notifications/emails/event-types', {
      // @ts-ignore
      appEnvironment,
    });

    return response?.data;
  }
}
